// components/Footer.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Link } from 'gatsby-theme-material-ui';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      flexDirection: 'column',
      flex: 1,
      padding: 0,
      margin: 0,
      marginVertical: theme.spacing(3),
      marginBottom: theme.spacing(5)
    },
    linksRow: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-around',
      flexDirection: 'row'
    },
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    copyright: {
      margin: theme.spacing(0)
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItem: 'center',
    }
  })
)

function Copyright() {
  const classes = useStyles();
  return (
    <Typography 
      variant="body2" 
      className={classes.copyright}
      color="textSecondary" 
      align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://tryamrc.com/">
        American Marine Research Company LLC
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


export default function Footer() {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <Container maxWidth="md" className={classes.container}>
        {/* <Divider className={classes.divider}/> */}
        <div className={classes.linksRow}>
          <Link to="/">Home</Link>
          <Link to="/legal#privacy">Privacy</Link>
          <Link to="/legal#eula">EULA</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/login">Login</Link>
          {/* <Link to="/contact">Support</Link> */}
        </div>
        <Divider className={classes.divider}/>
        <Copyright/>
      </Container>
    </div>
  )
}